import { format as formatDateFns, parseISO } from 'date-fns';
import type { FormatterFactory } from '../types';

export interface DateOptions {
  format?: string;
}

export function toDate(value: any): Date | null {
  if (value == null || value === '') {
    return null;
  }
  const parsed =
    typeof value === 'string'
      ? parseISO(value)
      : value instanceof Date
        ? value
        : new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export const date: FormatterFactory = (options: DateOptions = {}) => ({
  toText: (value) => {
    const parsed = toDate(value);
    if (!parsed) {
      return '';
    }
    if (options.format) {
      return formatDateFns(parsed, options.format);
    }
    const i18n = (globalThis as any).$app?.i18n;
    return i18n ? i18n.formatDate(parsed) : formatDateFns(parsed, 'yyyy-MM-dd');
  },

  toValue: (value) => toDate(value),
});
